import { render, staticRenderFns } from "./ManageMessages.vue?vue&type=template&id=4413e756&scoped=true"
import script from "./ManageMessages.vue?vue&type=script&lang=ts"
export * from "./ManageMessages.vue?vue&type=script&lang=ts"
import style0 from "./ManageMessages.vue?vue&type=style&index=0&id=4413e756&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4413e756",
  null
  
)

export default component.exports